import { useState, type FormEvent } from "react";

import { Button, ErrorNote, Input, Label, Logo, Panel } from "../components/ui";
import { useAuth } from "../lib/auth";
import { currentSlug, currentSurface } from "../lib/host";
import { useVenue } from "../lib/queries";

/** One login screen for both panels; the host decides which API it talks to. */
export function LoginPage() {
  const { login, loginError, loggingIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const operator = currentSurface() === "operator";
  const venue = useVenue();
  const slug = currentSlug();
  const host = window.location.hostname;

  async function submit(event: FormEvent) {
    event.preventDefault();
    try {
      await login(email, password);
    } catch {
      // Surfaced through loginError; nothing to do here.
    }
  }

  return (
    <main className="relative flex min-h-full items-center justify-center overflow-hidden px-5 py-12">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 [background:radial-gradient(60%_50%_at_0%_0%,rgba(139,92,246,0.35)_0%,rgba(139,92,246,0)_70%)]" />
      <div className="relative w-full max-w-[380px]">
        <div className="mb-[26px]">
          <Logo size={22} />
          <h1 className="mt-[22px] text-[28px] font-bold tracking-[-0.03em]">{operator ? "Panel operatora" : "Panel klubu"}</h1>
          <p className="mt-1.5 text-sm text-muted">
            {!operator && <>{venue.data?.name ?? slug} · </>}
            <span className="font-mono text-xs">{host}</span>
          </p>
        </div>

        <Panel padding={24}>
          <form onSubmit={submit} className="grid gap-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="email" autoComplete="username" placeholder="ty@klub.pl" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <Label htmlFor="password">Hasło</Label>
              <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {loginError && <ErrorNote>{loginError}</ErrorNote>}
            <Button type="submit" variant="primary" size="lg" block busy={loggingIn} className="mt-1">
              Zaloguj się
            </Button>
          </form>
        </Panel>

        {!operator && (
          <p className="mt-[22px] text-center text-[13px] text-muted">
            Obsługa przy drzwiach: <a href="/scanner">skaner</a>
          </p>
        )}
      </div>
    </main>
  );
}
